// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1__c9786e0eeac50293ba40","cls2":"FocusedNav-cls2___0f33769fb20772005dd FocusedNav-cls1__c9786e0eeac50293ba40"};